import { APP_NAME } from "../actions/auth.js";

export const themeStyle = getThemeStyle();

function getThemeStyle() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return {
        backgroundColor: "#F4F5FA",
        primaryColor: "#008668",
        primaryCardColor: "#e6f3f0",
        primaryColorLight: "#e6f3f0",
        textColor: "black",
        primaryButtonColor: "#26453e",
        primaryButtonTextColor: "black",
        secondaryButtonColor: "",
        secondaryColor: "#0f4139",
      };
    case "SKOLHIVE":
      return {
        backgroundColor: "#F4F5FA",
        primaryColor: "#8B5E34",
        primaryCardColor: "#FFEDD8",
        primaryColorLight: "#FFEDD8",
        textColor: "black",
        primaryButtonColor: "#8B5E34",
        primaryButtonTextColor: "black",
        secondaryButtonColor: "",
        secondaryColor: "#583101",
      };
    case "ELEMZY":
      return {
        backgroundColor: "#F4F5FA",
        primaryColor: "#3283c9",
        primaryCardColor: "#d7ecff",
        primaryColorLight: "#d7ecff",
        textColor: "black",
        primaryButtonColor: "#8B5E34",
        primaryButtonTextColor: "black",
        secondaryButtonColor: "",
        secondaryColor: "#212964",
      };
    case "CRIMSON":
      return {
        backgroundColor: "#e0efef",
        primaryColor: "#006666",
        primaryCardColor: "#e0efef",
        primaryColorLight: "#e0efef",
        textColor: "black",
        primaryButtonColor: "#8B5E34",
        primaryButtonTextColor: "black",
        secondaryButtonColor: "",
        secondaryColor: "#004c4c",
      };
  }
}
